import { useField } from "formik"
import { DynamicConfigField, DynamicConfigKey, PaymentMethodOptionValue } from "./formTypes"
import { PaymentMethodType } from "../../../../../modules/payments/paymentTypes"
import { SelectedMainUserState } from "../../../createOrder/createOrderTypes"
import { isAccountingDimensionKey } from "./helpers"
import { DynamicFormField } from "./DynamicFormField"
import { Logger } from "../../../../../lib/logging"

type AccountingDimensionControllerProps = {
    config: DynamicConfigField
    user?: SelectedMainUserState
}

export function AccountingDimensionController({ config, user }: AccountingDimensionControllerProps) {
    const [{ value: paymentMethodFieldValue }] = useField(DynamicConfigKey.PAYMENT_METHOD)
    const paymentValue: PaymentMethodOptionValue = paymentMethodFieldValue?.value
    const showAccountingDimensions = isAccountingDimensionKey(config.key) && paymentValue === PaymentMethodType.INVOICE

    new Logger("create-order").info(
        `Show accounting dimension for key ${
            config.key
        }? ${showAccountingDimensions} [isAccountingDimKey: ${isAccountingDimensionKey(
            config.key,
        )}, payment method: ${paymentValue}]`,
    )
    if (!showAccountingDimensions) return null

    return <DynamicFormField config={config} user={user} />
}
